import Vue from 'vue'
import Vuex from 'vuex'
import rundown from './modules/rundown' 
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    rundown
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})